export enum HeatingType {
  CENTRALIZZATO = 'CENTRALIZZATO',
  AUTONOMO = 'AUTONOMO',
}
